// src/components/sections/EventsList.jsx
import React from 'react';
import HeadingWithWatermark from '../HeadingWithWatermark';

const EventCard = ({ event }) => {
  return (
    <div className="bg-white border border-gray-300 rounded-lg shadow-sm hover:shadow-md transition-all relative">
      
      {/* Top Accent Bar */}
      <div className="h-1 w-full bg-[#1b73a7]" />

      <div className="p-6 flex flex-col h-full">

        {/* Date */}
        <span className="text-sm font-semibold text-[#1b73a7] mb-3">
          {event.date}
        </span>

        {/* Title */}
        <h3 className="text-lg font-semibold text-gray-900 mb-4 leading-snug">
          {event.title}
        </h3>

        {/* Location */}
        <div className="flex items-center text-gray-700 text-sm mb-6">
          <svg className="w-5 h-5 mr-2 text-[#1b73a7]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          {event.location}
        </div>

        <div className="mt-auto" />

        {/* Button */}
        <button className="w-full py-3 rounded-md font-medium text-sm text-white bg-[#1b73a7] hover:bg-[#155b87] transition">
          View Details
        </button>
      </div>
    </div>
  );
};

const EventsList = () => {
  const events = [
    {
      id: 1,
      title: "WASME Hosts KOSME Managing Director to Strengthen India-Korea SME and Startup Ecosystems",
      date: "Jan 12, 2026",
      location: "WASME, Noida",
    },
    {
      id: 2,
      title: "India Hosts UN World MSME Day 2025, Uniting 300+ Global Leaders for Innovation & Sustainability",
      date: "Jan 11 - Jan 12, 2026",
      location: "Bharat Mandapam, New Delhi",
    },
    {
      id: 3,
      title: "International Ambassadors Meet 2025: Celebrating Global Leadership and Visionaries",
      date: "Jan 06, 2026",
      location: "Embassy of Ethiopia, New Delhi",
    },
  ];

  return (
    <div className="bg-[#f4f6f8] pt-8 pb-8 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Heading Section */}
        <HeadingWithWatermark
          title="Press Releases"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />

        {/* Description for seniors */}
        

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventsList;
